// track() for the funnel code: a plain function (the prototype's API) that forwards to the production
// AnalyticsProvider (useAnalytics().track → flashfundme.com). TrackBridge, rendered once inside the providers,
// connects the two; calls made before it mounts are queued. Event names are unchanged.
import { useEffect } from "react";
import { useAnalytics } from "../../providers/analytics/AnalyticsProvider";

type Track = (event: string, props?: Record<string, unknown>) => void;

let impl: Track | null = null;
const queue: [string, Record<string, unknown> | undefined][] = [];

export function track(event: string, props?: Record<string, unknown>) {
  if (impl) impl(event, props);
  else queue.push([event, props]);
}

export function TrackBridge() {
  const { track: productionTrack } = useAnalytics();
  useEffect(() => {
    impl = productionTrack;
    queue.splice(0).forEach(([e, p]) => productionTrack(e, p));
    return () => {
      impl = null;
    };
  }, [productionTrack]);
  return null;
}
